<template>
  <div class="root" ref="root">
    <div id="main" class="Main" ref="main">
      <div class="wrapper--aspect-ratio">
        <div class="wrapper--child">
          <NotSupportedBrowser v-if="!isSupported" />
          <template v-else>
            <Loading v-if="isLoading" :loadingProgress="apartmentLoadingProgress" />
            <Apartment
              :apartmentNumber="apartmentNumberInUrl"
              :apartmentMappingName="apartmentMappingName"
              :investmentMeta="investmentMeta"
              :apartmentMeta="apartmentMeta"
              @loading-progress="apartmentLoadingProgressUpdated"
              @update-loading="updateLoading"
              :loading="loading"
              v-if="apartmentNumberInUrl && apartment"
            />
            <ErrorPage type="number-is-not-valid" v-else-if="apartmentNumberInUrl && !apartment" />
            <ErrorPage type="number-is-not-exist" v-else-if="!apartmentNumberInUrl && !apartment" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading"
import ErrorPage from "@/components/ErrorPage"
import NotSupportedBrowser from "@/components/NotSupportedBrowser"
import { getMetaInvestmentData, getMetaApartmentData, getApiData } from "@/utils/getData"
import { checkBrowserSupport } from "@/utils/supportedBrowsers"

export default {
  name: "App",
  data() {
    return {
      loading: 1,
      apartmentLoadingProgress: "",
      investmentMeta: null,
      apartmentMeta: null,
      apartment: null,
      apartmentNumberInUrl: null,
      apartmentMappingName: null,
      isSupported: false
    }
  },
  computed: {
    isLoading() {
      return this.loading > 0
    },
  },
  methods: {
    apartmentLoadingProgressUpdated(apartmentLoadingProgress) {
      this.apartmentLoadingProgress = apartmentLoadingProgress
    },
    findApartment(apartments, number) {
      return apartments.find((apartment) => {
        return apartment.name.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") == number.toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      })
    },
    getApartmentNumber() {
      const key = "number"

      const urlParams = new URLSearchParams(window.location.search)

      if (urlParams.has(key)) {
        return urlParams.get(key)
      } else {
        return false
      }
    },
    stopLoading() {
      return (this.loading = 0)
    },
    updateLoading(val) {
      this.loading = val
    },
    getLanguageFromUrl() {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const lang = urlParams.get('lang')
      if (lang) this.$i18n.locale = lang
    }
  },
  async created() {
    this.isSupported = checkBrowserSupport()
    this.getLanguageFromUrl()

    this.investmentMeta = await getMetaInvestmentData()
    const apiData = await getApiData()
    const number = this.getApartmentNumber()
    let apartment
    if (number) {
      this.apartmentNumberInUrl = number
      apartment = this.findApartment(apiData, number)
      this.apartmentMappingName = await apartment?.mappingName
    } else {
      this.apartmentNumberInUrl = "0"
      this.stopLoading()
    }
    if (apartment) {
      this.apartmentMeta = await getMetaApartmentData(this.apartmentMappingName)
      this.apartment = await apartment
      this.apartmentMappingName = await this.apartment?.mappingName
      if (!this.apartmentMeta) {
        this.apartment = undefined
        this.stopLoading()
      }
    } else {
      this.stopLoading()
    }
  },
  components: {
    Apartment: () => import("@/components/Apartment.vue"),
    Loading,
    ErrorPage,
    NotSupportedBrowser
  },
}
</script>

<style lang="scss">
@import "~@/styles/reset.scss";
@import "~@/styles/Main.scss";
</style>
